import { render, staticRenderFns } from "./CategoryProductsGrid.vue?vue&type=template&id=31f853a0"
import script from "./CategoryProductsGrid.vue?vue&type=script&lang=js"
export * from "./CategoryProductsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports